function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Home_theator",
  "data-name": "Home theator"
}, /*#__PURE__*/React.createElement("path", {
  d: "m4 22.586 6-6v-2.586h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 10h6v2h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 27.586 6-6v-2.172l-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 38h6v-13.586l-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 38h30a1 1 0 0 0 1-1v-17a1 1 0 0 0 -1-1h-30a1 1 0 0 0 -1 1v17a1 1 0 0 0 1 1zm0-17a1 1 0 0 1 1-1h28a1 1 0 0 1 1 1v15a1 1 0 0 1 -1 1h-28a1 1 0 0 1 -1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19 22h26v13h-26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54 22.586 6-6v-2.586h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54 10h6v2h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54 27.586 6-6v-2.172l-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54 38h6v-13.586l-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9 60h-1v-20h-2v20h-1a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m59 60h-1v-20h-2v20h-1a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m39 56a3 3 0 1 0 -3-3 3 3 0 0 0 3 3zm0-5a2 2 0 1 1 -2 2 2 2 0 0 1 2-2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 53,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "m19 60h26a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1h-26a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1zm20-12a5 5 0 1 1 -5 5 5.006 5.006 0 0 1 5-5zm-13-1a6 6 0 1 1 -6 6 6.006 6.006 0 0 1 6-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26 57a4 4 0 1 0 -4-4 4 4 0 0 0 4 4zm0-7a3 3 0 1 1 -3 3 3 3 0 0 1 3-3z"
}));

function Svg69(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg69);
export default __webpack_public_path__ + "static/media/6_9.4743f512.svg";
export { ForwardRef as ReactComponent };